export interface CurrentUser {
    firstName: string;
    lastName: string;
    username: string;
}

export function isSupportUser(user: CurrentUser | null | undefined): boolean {
    if (!user) return false;
    const validLastNames = ['Superuser', 'Support', 'Thomas Sverker'];
    const validUsernames = ['superuser', 'support', 'thsv'];
    return user.firstName === 'CleverApps'
        && validLastNames.includes(user.lastName)
        && validUsernames.includes(user.username);
}

export function isAngularSupportUser(): boolean {
    try {
        const ng = (window as any).angular;
        if (!ng) return false;
        return ng.element(document.body).injector().get('devFeaturesDialogService').isSupportUser();
    } catch {
        return false;
    }
}
